import React from "react";
import * as colors from "../helpers/constants/colors";
import { greyPalette } from "../helpers/constants/colorPalettes";

export default function({ label, isSelected, onClick, style, ...props }) {
    return (
        <button
            onClick={onClick}
            className="wevo-filter-button"
            style={{
                backgroundColor: isSelected ? colors.accent : colors.white,
                border: `1px solid ${
                    isSelected ? colors.accent : greyPalette.medGrey
                }`,
                color: isSelected ? colors.white : greyPalette.medGrey,
                ...style
            }}
            {...props}
        >
            <h5>{label}</h5>
        </button>
    );
}



// WEBPACK FOOTER //
// ./src/components/ToggleButton.js